/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { TextureLoader } from "three";
/**
 * Loads an image texture from a URL using THREE.js TextureLoader.
 * Handles CORS and cross-origin settings.
 *
 * @param src The URL of the image to load
 * @returns A Promise that resolves to a loaded Texture
 */
export const loadImageTexture = (src) => {
    return new Promise((resolve, reject) => {
        const loader = new TextureLoader();
        loader.setCrossOrigin("anonymous");
        loader.load(src, (texture) => {
            resolve(texture);
        }, undefined, (error) => {
            reject(error);
        });
    });
};
//# sourceMappingURL=image-loader.js.map